import React from 'react';
import PhoneEmailMsg from '../CallToAction/PhoneEmailMsg';
import Hr from '../Hr';
import * as themeStyles from '../../assets/theme.module.scss';

const Consult = () => (
    <div className={themeStyles.container}>
        <h2>專業諮詢</h2>
        <Hr />
        <PhoneEmailMsg />
    </div>
);

export default Consult;
